<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtEmptyMessage } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'companyTable',
  components: { JtEmptyMessage },
  mixins: [JtDataTable]
})
export default class CompanyPage extends Vue {
  levelList = []

  beforeMount () {
    this.formatardados()
  }

  async formatardados () {
    const { registros } = await repository.resolveDatatableModel(
      'organizationalStructureLevel.pesquisar'
    )
    this.levelList = registros.flatMap((col) => [
      {
        label: col.name,
        name: 'level_' + col.level,
        field: 'level_' + col.level,
        model: 'level_' + col.level
      }
    ])
  }

  get visibleColumns () {
    return this.columns.map((col) => col.name || col.model)
  }

  tableDataFormatter (data) {
    return data.flatMap(
      (lin) => (lin = { ...lin, ...JSON.parse(lin.organizationalStructure) })
    )
  }

  get columns () {
    let colunas = this.fields.map((col) => {
      col.name = col.name || col.model
      col.field = col.name
      this.label(col, { ...this.extraParams })
      col.align = col.align || 'center'
      col.sortable = true
      return col
    })
    const index = colunas.length - 1
    colunas = colunas.concat(this.levelList)
    const temp = colunas.splice(index).reverse()
    return colunas.concat(temp)
  }

  actionButton (button, params) {
    delete params.organizationalStructure
    this.$emit('action-button', button, params, this)
  }
}
</script>
<style lang="stylus" scoped></style>
